export default {
  categoryId: ({ categories }) => (slug) => {
    const c = categories.find(c => c.slug === slug)
    return c ? c.term_id : false
  },
  tagId: ({ tags }) => (slug) => {
    const c = tags.find(c => c.slug === slug)
    return c ? c.term_id : false
  },
  taxNames ({ categories, tags }) {
    const m = {}
    categories.forEach((c) => {
      m[c.slug] = c.name
    })
    tags.forEach((t) => {
      m[t.slug] = t.name
    })
    return m
  }
}
